<template>
  <el-col>
    <el-card class="data" v_loading="loading">
      <div class="data-title" slot="header">
        <div class="tabs">
          <div
            class="tab"
            v-for="tab in tabs"
            :key="tab.id"
            @click.prevent="selectTab(tab)"
            :class="{ 'is-active': tab.isActive }"
          >
            <div class="top-border"></div>
            <span>{{ commaNum(tab.number) }}</span>
            <p>{{ tab.label }}</p>
          </div>
        </div>
      </div>
      <div class="chart" v-if="activeTabName === 'views'">
        <GChart
          type="LineChart"
          :data="period_chart.views"
          :options="LineChartSett"
          v-if="period_chart.views && period_chart.views.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
      </div>
      <div class="chart" v-if="activeTabName === 'subscribers'">
        <GChart
          type="LineChart"
          :data="period_chart.subscribers"
          :options="LineChartSett"
          v-if="period_chart.subscribers && period_chart.subscribers.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
      </div>
      <div class="chart" v-if="activeTabName === 'videos'">
        <GChart
          type="LineChart"
          :data="period_chart.videos"
          :options="LineChartSett"
          v-if="period_chart.videos && period_chart.videos.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
      </div>
      <div class="chart" v-if="activeTabName === 'previews'">
        <GChart
          type="LineChart"
          :data="period_chart.previews"
          :options="LineChartSett"
          v-if="period_chart.previews && period_chart.previews.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
      </div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('artistDashboard', [
      'PieChartSett',
      'info',
      'loading',
      'artist_track',
      'artist_label'
    ]),
    ...mapState('artistDashboard', ['LineChartSett']),
    ...mapGetters('artistDashboard', ['period_chart'])
  },

  data() {
    return {
      selectedCommand: 'Date range',
      tabs: [
        {
          title: 'views',
          label: 'Views',
          isActive: true,
          number: 0
        },
        {
          title: 'subscribers',
          label: 'Subscribers',
          isActive: false,
          number: 0
        },
        {
          title: 'videos',
          label: 'No. Videos',
          isActive: false,
          number: 0
        },
        {
          title: 'previews',
          label: 'Previews',
          isActive: false,
          number: 0
        }
      ],
      activeTabName: 'views'
    }
  },

  methods: {
    ...mapActions('artistDashboard', ['readInfo', 'readPeriodInfo']),
    ...mapMutations('artistDashboard', ['setInfoData', 'setInfoPeriodData']),

    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.label == selectedTab.label
        this.activeTabName = selectedTab.title
      })
    },
    handleCommand(command) {
      this.selectedCommand = command
    }
  },

  watch: {
    artist_track: function(valN, valO) {
      if (valN !== null) {
        this.readInfo()
        this.readPeriodInfo()
      }
    },
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readInfo()
        this.readPeriodInfo()
      }
    },
    info: function(val) {
      if (typeof val !== 'undefined') {
        this.tabs.map(s => {
          if (typeof val.views !== 'undefined' && s.title == 'views') {
            s.number = val.views
          } else if (
            typeof val.subscribers !== 'undefined' &&
            s.title == 'subscribers'
          ) {
            s.number = val.subscribers
          } else if (typeof val.video !== 'undefined' && s.title == 'videos') {
            s.number = val.video
          } else if (
            typeof val.previews !== 'undefined' &&
            s.title == 'previews'
          ) {
            s.number = val.previews
          } else {
            s.number = 0
          }
        })
      } else {
        this.tabs.map(s => {
          s.number = 0
        })
      }
    }
  },

  created() {
    this.readInfo()
    this.readPeriodInfo()
  },

  destroyed() {
    this.setInfoData({})
    this.setInfoPeriodData({})
  }
}
</script>
